import type { ReactNode } from "react";

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";

interface CollapsibleMenuItemProps {
  trigger: ReactNode;
  hoverContent: ReactNode;
  inlineContent: ReactNode;
  hoverCardWidth?: string;
  defaultOpen?: boolean;
}

export function CollapsibleMenuItem({
  trigger,
  hoverContent,
  inlineContent,
  hoverCardWidth = "w-56",
  defaultOpen = true,
}: CollapsibleMenuItemProps) {
  const sidebar = useSidebar();

  return (
    <Collapsible defaultOpen={defaultOpen} className="group/collapsible">
      <SidebarMenuItem>
        <HoverCard openDelay={200}>
          <HoverCardTrigger asChild>
            <CollapsibleTrigger asChild>{trigger}</CollapsibleTrigger>
          </HoverCardTrigger>
          {sidebar.state === "collapsed" && (
            <HoverCardContent side="right" align="start" className={`${hoverCardWidth} p-2`}>
              <div className="flex flex-col gap-1">{hoverContent}</div>
            </HoverCardContent>
          )}
        </HoverCard>
        <CollapsibleContent>{inlineContent}</CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  );
}
